module.exports = "<div id=qanda> <div class=qanda-title data-bind=\"click: toggle\"> <div class=qanda-title-icon> <span>?</span> </div> <div class=qanda-title-text data-bind=\"visible: !hidable()\"> <span>常见问题</span> </div> </div> <div class=qanda-content> <div data-bind=\"visible: hidable, click: toggle\" class=qanda-hide> 常见问题 </div> <ul data-bind=\"visible: !hidable(), foreach: list\"> <li data-bind=\"attr: {title: description}\"> <span class=qanda-content-icon>Q</span> <a target=blank data-bind=\"text: description, attr:{href: $parent.url()+id}\"></a> </li> </ul> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/qanda-tips/index.html
// module id = 439
// module chunks = 144